import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Button, Grid, Radio, TextField, Typography} from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { calculateDistanceTimeFrEpoch } from '../../utils/util';
import {DeleteIcon, RadioIcon, RadioCheckedIcon, NotificationsIcon} from '../../components/icons'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getAppCfg, getLanguage } from '../../utils/common';
import classNames from 'classnames';
import themeCss from '../../theme.css';

const styles = theme => ({
    container:{
        padding: theme.spacing(6,4,4,4)
    },
    boxItemPre:{
       // padding: theme.spacing(0,2,0,0)
    },
    item: {
        padding: theme.spacing(0, 2),
    },
    boxItemContent: {
        padding: theme.spacing(2,4,2,4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        //marginBottom: theme.spacing(1.5),
        border: '10px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor:theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
    },
    darkboxItemContent: {
        padding: 16,
        marginTop: theme.spacing(2),
        //marginBottom: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
        // backgroundColor: theme.palette.background.header,
        borderRadius: 12,
        backgroundColor: theme.palette.background.main,
        boxShadow: theme.boxShadow.secondary,
        cursor: 'pointer',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        
        shadowOpacity: 1,
        shadowRadius: 3,
        elevation: 5,
        // border: '1px solid ' + theme.palette.border.primary,
    },
    notification_read: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        borderRadius: theme.spacing(3),
        shadowColor: theme.palette.background.main,
        shadowOffset: { width: 2, height: 2 },
        shadowRadius: 4,
        elevation: 5,
        shadowOpacity:1,
        alignSelf: 'center',
        marginLeft: theme.spacing(1)
    },
    bg_icon:{
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    },
    content: {
        padding: theme.spacing(1),
        whiteSpace: 'pre-line',
    },
    image: {
        width: 32,
        height: 32,
        borderRadius: 32,
        objectFit:'cover',
        borderWidth: 1,
    },
    wraptext: {
        lineHeight:'1.25em',
        // height:'2em',
        overflow: "hidden",
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 4,
        '-webkit-box-orient': 'vertical'
    },
    otherButton: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        boxShadow:'none',
        borderRadius: theme.spacing(10),
        borderColor: theme.palette.background.transparent,
        opacity: 1,
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        padding: theme.spacing(1.8,1,0,1),
       // backgroundColor: theme.palette.icon.trash,
        '&:hover': {
                opacity: 0.5,
            },

        position: 'fixed',
        top:theme.spacing(6),
        right:theme.spacing(6),
        zIndex: 1001,
    },
    radio:{
        cursor: 'pointer'
    },
    bell:{
        display:'flex',
    },
    viewed: {
        opacity: 0.5,
    },
    iconBell: {
        background: theme.palette.primary.main,
        padding: theme.spacing(1),
        width: 32,
        height: 32,
        borderRadius: 32,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },
});
function NotificationsView(props) {
    const [isEdit, setIsEdit] = useState(false);

    const onEditNotifications = () =>{
        if(isEdit){
            props.clearRemoveItem();
        }
        setIsEdit(!isEdit);
    }
    const onDeleteMultiNotification = async() =>{
        var result = await props.onDeleteMultiNotification();
        setIsEdit(result ? false : true);
    }

    const {classes, t , notifications, open, onClose, handleLoadMore, onShowDetail, showLoading, hasMore,showLoadMore, removeItems} = props
    console.log('removeItems===',removeItems)
    console.log('isEdit===',isEdit)
    let language = getLanguage("LANGUAGE");
    console.log("language ===", language);
    return (
            <DrawerCustom open={open} onClose={onClose} title={t('notifications')}
               enableBack={{ 
                    //className={classes.otherButton},
                    icon: !isEdit ? <DeleteIcon /> : null, 
                    action: isEdit ? onDeleteMultiNotification : onEditNotifications, 
                    active: !isEdit || removeItems.length > 0,
                }}
                children={       
                    <Grid xs={12} item>
                        {/* <Grid xs={12} item>
                            <CustomTypo variant='h3' color='onPrimary'>{t('notifications')}</CustomTypo>
                        </Grid> */}
                            {/*isEdit==false ?  <Grid xs={12} item container justify='flex-end' >
                                <Button container color='primary'>{t('mark_all_as_read')}</Button>
                            </Grid> : <></> */}
                            {isEdit ? <Grid xs={12} item container display='flex'>
                                <Grid xs={6}>
                                    <Button color='primary' onClick={()=>onEditNotifications()}>{(t('btn_cancel'))}</Button>
                                </Grid>
                                <Grid xs={6} container justifyContent='flex-end'>
                                    <Button color='primary' onClick={()=>onDeleteMultiNotification()}>{(t('btn_delete'))}</Button>
                                </Grid>
                            </Grid> : <></>}
                            <Grid xs={12} item container justify='center' >
                                {showLoading?<CustomizedCircularProgress/>:null}
                            </Grid> 
                            <Grid xs={12} item>
                                <InfiniteScroll
                                    dataLength={notifications.length} //This is important field to render the next data
                                    next={handleLoadMore}
                                    hasMore={hasMore}
                                    height={window.innerHeight}
                                    loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                                    >
                                    <Grid xs={12} item container className={classes.item}>
                                        {notifications.map((item,index)=><NotificationItem 
                                            key={index} item ={item} 
                                            onShowDetail={onShowDetail} 
                                            onDeleleNotification={props.onDeleleNotification} 
                                            classes={classes}
                                            isEdit={isEdit}
                                            addItemToRemove={props.addItemToRemove} 
                                            removeItems={props.removeItems}/>)}
                                    </Grid>
                                </InfiniteScroll>
                            </Grid>

                    </Grid>
                    }
            />
    );
}

function NotificationItem(props){
    var item = props.item;
    var removeItems = props.removeItems;
    var itemExist = removeItems.filter(i => {
        return i.id == item.id
    })
    let config=getAppCfg();
    var isDarkMode= config.appearance.dark_mode;
    console.log('isDarkMode',isDarkMode)
    console.log('item',item)
    //console.log('itemExist===',itemExist)
    const {classes} = props;
    return (
            <Grid item container>
               <Grid xs={12} item className={classes.boxItemPre}>
                    <Grid item container className={classNames([isDarkMode ? classes.darkboxItemContent : classes.boxItemContent, !props.isEdit && item.is_viewed ? classes.viewed : null ])} onClick={!props.isEdit ? () => props.onShowDetail(item) :() => props.addItemToRemove(item)} >
                        <Grid xs={12} sm={12} item container alignItems='center'>
                        {props.isEdit &&<Grid xs={2} sm={1} item justifyContent='center' className={classes.radio} >
                            {itemExist && itemExist.length > 0 ? <RadioCheckedIcon/> : <RadioIcon/>}
                        </Grid>}
                        {!props.isEdit  &&  <Grid xs={2} sm={1}>
                            {item.in_app_image_url ? <img className={classes.image} src={item.in_app_image_url} /> : <Grid item xs={12} className={classes.iconBell}>
                                <NotificationsIcon fill={themeCss.palette.background.secondary} style={{ width: 20, height: 20}}/>
                            </Grid>}
                        </Grid> }
                            <Grid xs={10} item >
                            {item&&<CustomTypo variant={'subtitle2'} color={isDarkMode ? 'onPrimary' :'primary'}>{item.subject ? item.subject : ""}</CustomTypo>}                            
                            <CustomTypo variant='body2' color={isDarkMode ? 'onPrimary' :'primary'}>
                                {item&&item.subtitle && <CustomTypo >{item.subtitle}</CustomTypo>}
                                {item&&item.created_on ? calculateDistanceTimeFrEpoch(item.created_on) : ""}
                                {/* <IconButton onClick={()=>props.onDeleleNotification(item.id)}><DeleteIcon/></IconButton> */}
                            </CustomTypo>
                            </Grid>
                        </Grid>
                        {/* <Grid xs={12} item className={classes.content}>
                            {item?<CustomTypo variant='body2' color='primary' className={classes.wraptext}>{item.content ? renderHTML(item.content) : ""}</CustomTypo>:null}
                        </Grid> */}
                    </Grid>
                </Grid> 
                {/*<Grid xs={1} item container justify='flex-end' alignItems='center'>
                {props.isEdit &&<Grid item className={classes.radio} onClick={() => props.addItemToRemove(item)}>
                    {itemExist && itemExist.length > 0 ? <RadioCheckedIcon/> : <RadioIcon/>}
                </Grid>}
                    </Grid>*/}

            </Grid>
        )
}
export default withStyles(styles)(withTranslation()(NotificationsView));